import { createFileRoute } from '@tanstack/react-router'

import CustomerBookTablePage from '@/views/o2o/customer-book-table/customer-book-table.page'

export const Route = createFileRoute('/phong-nha/o2o/customer-book-table')({
  component: CustomerBookTablePage,
})

